/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_TBILLTABLE_DATA = 'GET_TBILLTABLE_DATA';
export const ADD_NEW_TBILL_DATA = 'ADD_NEW_TBILL_DATA';
export const GET_TBILLTABLE_EDITED_DATA = 'GET_TBILLTABLE_EDITED_DATA';
export const UPDATE_TBILLTABLE_DATA = 'UPDATE_TBILLTABLE_DATA';
export const VIEW_HISTORY = 'VIEW_HISTORY';
export const TBILL_ERROR = 'TBILL_ERROR';
export const TBILL_EXTRA_STATE = 'TBILL_EXTRA_STATE';
export const TBILL_CLEAR_REDUX_STORE = 'TBILL_CLEAR_REDUX_STORE';
